export const FETCH_PLAYLIST_SUCCESS = 'FETCH_PLAYLIST_SUCCESS';
export const FETCH_USER_PLAYLIST_SUCCESS = 'FETCH_USER_PLAYLIST_SUCCESS';
export const FETCH_CURRENT_PLAYLIST_SUCCESS = 'FETCH_CURRENT_PLAYLIST_SUCCESS'
// export const FETCH_DISCOVER_PLAYLIST_SUCCESS = 'FETCH_DISCOVER_PLAYLIST_SUCCESS';
export const STORE_HISTORY = 'STORE_HISTORY';
import Cookies from 'js-cookie';
import store from 'store';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';

export const storeHistory = historyy => ({
  type: STORE_HISTORY,
  history: { historyy }
});

export const fetchPlaylistSuccess = playlist => ({
  type: FETCH_PLAYLIST_SUCCESS,
  payload: { playlist }
});

export const fetchUserPlaylistSuccess = playlists => ({
  type: FETCH_USER_PLAYLIST_SUCCESS,
  payload: { playlists }
});

export const fetchCurrentPlaylistSuccess = playlistdd => ({
  type: FETCH_CURRENT_PLAYLIST_SUCCESS,
  payload: {playlistdd},
})

export function fetchArtworksCollection(dispatch,userId,playlistId) {
  return bdReq
  .get(`/users/${userId}/playlists/${playlistId}`)
  .then(({ success, body }) => {
    if (!success) {
      fetchArtworksCollection(dispatch, userId, playlistId);
      return;
    }
    dispatch(fetchCurrentPlaylistSuccess(body));
  })
  .catch(error => {
    fetchUserPlaylist(dispatch, userId);
  });
}

// export const fetchDiscoverPlaylistSuccess = playlistsd => ({
//   type: FETCH_DISCOVER_PLAYLIST_SUCCESS,
//   payload: { playlistsd }
// });

// fetch user artworks
export function fetchPlaylist(dispatch) {
  let user = store.get('auth__user') || '';
  let id = user.id ? user.id : user || '';
  const url = bdAuth.getToken() ? `/users/${id}/playlists/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx` : '/users/anonymous/playlists/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx';
  return bdReq
    .get(url)
    .then(({ success, body }) => {
      if (!success) {
        fetchPlaylist(dispatch);
        return;
      }
      dispatch(fetchPlaylistSuccess(body));
    })
    .catch(err => {
      fetchPlaylist(dispatch);
    });
}

// fetch user playlists
export function fetchUserPlaylist(dispatch, userId) {
  return bdReq
    .get(`/users/${userId}/home`)
    .then(({ success, body }) => {
      if (!success) {
        fetchUserPlaylist(dispatch, userId);
        return;
      }
      dispatch(fetchUserPlaylistSuccess(body));
    })
    .catch(error => {
      fetchUserPlaylist(dispatch, userId);
    });
}

// fetch discover playlists
// export function fetchDiscoverPlaylist(dispatch, userId) {
//   return bdReq
//     .get(`/users/${userId}/discover`)
//     .then(({ success, body }) => { 
//       if (!success) {
//         fetchDiscoverPlaylist(dispatch, userId);
//         return;
//       }
//       dispatch(fetchDiscoverPlaylistSuccess(body));
//     })
//     .catch(error => {
//       fetchDiscoverPlaylist(dispatch, userId);
//     });
// }

export function fetchSonyFreePlaylist(dispatch) {
  return bdReq
    .get('/users/anonymous/playlists/Y0d4aGVXeHBjM1E9N2VjNTM3ODAtYzJjNS0xMWU4LTg3MjctYWIwMzQwOWNmNjg0')
    .then(({ success, body }) => {
      if (!success) {
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          body: body.message,
        });
        return;
      }
    })
    .catch(err => { });
}